import { ALL_DOCS_FILTER, FOR_TRAINING_FILTER } from '../TrainingFilter';

export const trainingFilterLabelKeys: Record<string, string> = {
  [ALL_DOCS_FILTER]: 'labels.allDocuments',
  [FOR_TRAINING_FILTER]: 'labels.trainingDocuments',
};
